import VueRouter from 'vue-router'
import Vue from 'vue'

import buy from '../components/components/buy'
import download from '../components/components/download'
import productcenter from '../components/components/productcenter'

import productcenterjgyj from '../components/components/productcenterjgyj'
import productcentersj from '../components/components/productcentersj'
import productcenterxgj from '../components/components/productcenterxgj'
import productcenterzyjy from '../components/components/productcenterzyjy'
import productcenterqtgn from '../components/components/productcenterqtgn'
import serive from '../components/components/serive'
// import success from '../components/components/success'
import trade from '../components/components/trade'
import aboveall from '../components/components/aboveall'
import proc from '../components/components/proc'
import shengjishuoming from '../components/components/shengjishuoming'
import succ from '../components/components/succ'
Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}
const routes=[

  {
    path:"/aboveall",
    component:aboveall,
    name:"aboveall",
    
  },
  
  {
    path:"/buy/:id",
    component:buy,
    name:"buy"
  },
  {
    path:"/download",
    component:download,
    name:"download"
  },
  {
    path:"/proc",
    component:proc,
    // name:"proc",
    children:[
      {
        path:"productcenter/:id",
        component:productcenter,
        name:"productcenter",
      },
      {
        path:"productcenterxgj/:id",
        component:productcenterxgj,
        name:"productcenterxgj",
      },
      {
        path:"productcenterzyjy/:id",
        component:productcenterzyjy,
        name:"productcenterzyjy",
      },
      
      {
        path:"productcenterjgyj/:id",
        component:productcenterjgyj,
        name:"productcenterjgyj",
      },
      {
        path:"productcenterqtgn/:id",
        component:productcenterqtgn,
        name:"productcenterqtgn",
      },
      {
        path:"productcentersj",
        component:productcentersj,
        name:"productcentersj",
      },
      {
        path:"shengjishuoming",
        component:shengjishuoming,
        name:"shengjishuoming",
      },
      {
        path:"",
        component:productcenterjgyj,
        name:"proc_redirect",
      },
      // {path: '*', redirect: '/productcenterjgyj/gzx'}
    ]
  },
 
  {
    path:"/serive",
    component:serive,
    name:"serive"
  },
  {
    path:"/success",
    component:succ,
    name:"success"
  },
  {
    path:"/trade",
    component:trade,
    name:"trade"
  },
  {path: '*', redirect: '/aboveall'}


]

const router = new VueRouter({
  mode: 'hash',   
 
    routes
  })
export default router